'use client';

import Rate from 'rc-rate';
import 'rc-rate/assets/index.css';
import './rating.css';

interface IRatingProps {
  rating: number;
  count: number;
}

export const Rating = ({ rating, count }: IRatingProps) => {
  return (
    <div className="flex items-center gap-2 font-inter">
      <div className="flex items-center text-md">
        <Rate count={5} value={rating} defaultValue={5} allowHalf={true} disabled={true} />
        <span className="text-sm lg:text-md rating__details rating__score">{rating}</span>
      </div>
      <span className="text-sm lg:text-md text-gray-500 rating__details rating__reviews">·</span>
      <span className="text-sm lg:text-md text-gray-500 rating__details rating__reviews">{count} reviews</span>
    </div>
  );
};
